export default "__VITE_ASSET__D_p1HBfb__"